<template>
    <img @click="ttsShow()" v-bind="$props" :src="imageURL" :style="computedStyles" />
</template>
<script>
const {getImageURL} = require("@/components/General/utils")
export default {
    name : 'show-image',
    props : {
        src : String,
        tts : String
    },
    methods : {
        ttsShow(){
            if(this.tts && this.tts.length){
                this.$common.readQuestionLoud(this.tts)
            }
        }
    },
    computed : {
        imageURL(){
            return getImageURL(this.src)
        },
        computedStyles(){
            let styles = {}
            if(this.tts && this.tts.length){
                styles['cursor'] = "pointer"
            }
            return styles
        }
    }
}
</script>
